import { render, staticRenderFns } from "./bedPersonList.vue?vue&type=template&id=0aa8bc63&scoped=true&"
import script from "./bedPersonList.vue?vue&type=script&lang=js&"
export * from "./bedPersonList.vue?vue&type=script&lang=js&"
import style0 from "./bedPersonList.vue?vue&type=style&index=0&id=0aa8bc63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa8bc63",
  null
  
)

export default component.exports